<template>
    <v-sheet>
      <v-form v-model="valid">
        <v-text-field prepend-icon="mdi-script-text" required readonly v-model="topic"></v-text-field>
        <v-text-field prepend-icon="mdi-domain" required :rules="nonEmptyRules" v-model="companyName" :placeholder="this.$t('company_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-phone" required :rules="phoneNumberRules" v-model="phoneNumber" :placeholder="this.$t('phone_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-mail" required :rules="emailRules" v-model="mail" :placeholder="this.$t('email_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-human" required :rules="nameSurnameRules" v-model="nameSurname" :placeholder="this.$t('name_surname_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-account" required :rules="participantsNumberRules" v-model="participantsNumber" :placeholder="this.$t('participants_number_placeholder')"></v-text-field>
        <v-btn :disabled="!valid" block @click="handleSubmitForm" :color="!valid ? '' : 'green'">{{$t('submit')}}</v-btn>
        <v-snackbar
            v-model="sendedMail"
            color="green"
            rounded="pill"
            >
            {{ $t('sended_mail') }}

            <template v-slot:action="{ attrs }">
                <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="sendedMail = false"
                >
                {{$t('close')}}
                </v-btn>
            </template>
        </v-snackbar>
        <br />
        <v-btn block to="/trainings/trainings_schedule" color="warning">{{$t('return')}}</v-btn>
      </v-form>
    </v-sheet>
  </template>
  
  <script>
  import axios from "axios";
  import config from "@/config"
  
  export default {
  
    props: ['trainingNameProp', 'dateProp'],
    methods: {
      handleSubmitForm() {
        let message = `Person: ${this.nameSurname} with phone number: ${this.phoneNumber} and email: ${this.mail} require contact about ${this.topic}, date: ${this.dateProp}. Estimated number of people: ${this.participantsNumber}`;
        let postData = {
          template: 'contact',
          title: "Require contact",
          topic: "Require contact",
          message: {message: message, mail: this.mail}
        }
        axios.post(config.MAIL_API_URL, postData)
            .then(response => console.debug('response', response))
            .then(this.sendedMail = true);
      }
    },
  
    data() {
      return {
        valid: false,
        emailRules: [
          v => !!v || this.$t('email_required'),
          v => /.+@.+/.test(v) || this.$t('email_not_valid'),
        ],
        nonEmptyRules: [
          v => !!v || this.$t('field_required')
        ],
        nameSurnameRules: [
            v => !!v || this.$t('name_surname_required'),
        ],
        phoneNumberRules: [
            v => !!v || this.$t('phone_required'),
        ],
        participantsNumberRules: [
            v => !isNaN(v) || this.$t('field_not_nan'),
            v => !!v || this.$t('field_required'),
        ],
        topic: this.trainingNameProp,
        mail: '',
        nameSurname: '',
        phoneNumber: '',
        participantsNumber: '',
        message: '',
        sendedMail: false,
      }
    },
  
  }
  </script>
  